import { Props_SocialBannerProps } from "./SocialBanner.props"

export const SocialBanner = (props: Props_SocialBannerProps) => {
    const {heading, instagramLink, linkedinLink, xLink, facebookLink} = props

    return (
        <section className="attrax-social-banner">
            <div className="attrax-social-banner__container">
                <div className="attrax-social-banner__container-inner">
                    {heading.text?.value && (
                        <h2 className="attrax-social-banner__heading">
                            {heading.highlighedText.value}
                            <span>{heading.text.value}</span>
                        </h2>
                    )}
                    <div className="attrax-social-banner__links">
                        {facebookLink.url.value && (
                            <a href={facebookLink.url.value}
                               target="_blank"
                               rel="noopener noreferrer"
                               aria-label={facebookLink.ariaLabel.value || "Facebook"}
                               className="attrax-social-banner__link">
                                <span className="attrax-social-banner__icon attrax-social-banner__icon--facebook"></span>
                            </a>
                        )}
                        {instagramLink.url.value && (
                            <a href={instagramLink.url.value}
                               target="_blank"
                               rel="noopener noreferrer"
                               aria-label={instagramLink.ariaLabel.value || "Instagram"}
                               className="attrax-social-banner__link">
                                <span className="attrax-social-banner__icon attrax-social-banner__icon--instagram"></span>
                            </a>
                        )}
                        {linkedinLink.url.value && (
                            <a href={linkedinLink.url.value}
                               target="_blank"
                               rel="noopener noreferrer"
                               aria-label={linkedinLink.ariaLabel.value || "LinkedIn"}
                               className="attrax-social-banner__link">
                                <span className="attrax-social-banner__icon attrax-social-banner__icon--linkedin"></span>
                            </a>
                        )}
                        {xLink.url.value && (
                            <a href={xLink.url.value}
                               target="_blank"
                               rel="noopener noreferrer"
                               aria-label={xLink.ariaLabel.value || "X (Twitter)"}
                               className="attrax-social-banner__link">
                                <span className="attrax-social-banner__icon attrax-social-banner__icon--twitter"></span>
                            </a>
                        )}
                    </div>
                </div>
                </div>
                
        </section>
    )
}